// eslint-disable-next-line import/no-anonymous-default-export
export default {
  LOGIN: {
    index: "/login",
  },
  MEMBER: {
    index: "/member",
    list: "/member/list",
  },
  BURIAL: {
    index: "/burial",
    list: "/burial/list",
    add: "/burial/add",
  },
  RECOMMEND: {
    list: "/recommend/list",
  },
  PARKCONSULTING: {
    index: "/contact/parkConsulting",
    list: "/contact/parkConsulting/list",
  },
  ASKGRAVEMOVE: {
    index: "/contact/askGraveMove",
    list: "/contact/askGraveMove/list",
  },
  GRAVE: {
    index: "/contact/grave",
    list: "contact/grave/list",
  },
  FUNERAL: {
    index: "/contact/funeral",
    list: "contact/funeral/list",
  },
  INHERITANCE: {
    index: "/contact/inheritance",
    list: "contact/inheritance/list",
  },
  MEMORY: {
    index: "/contact/memory",
    list: "contact/memory/list",
  },
  NOTICE: {
    index: "/notice",
    list: "/notice/list",
  },
  ONELINENOTICE: {
    list: "/onelineNotice/list",
  },
  REVIEW: {
    index: "/review",
    list: "/review/list",
  },
  FAQ: {
    index: "/faq",
    list: "/faq/list",
  },
  INQUIRY: {
    index: "/inquiry",
    list: "/inquiry/list",
  },
  COOPERATE: {
    index: "/cooperate",
    list: "/cooperate/list",
  },
  BLOG: {
    index: "/blog",
    list: "/blog/list",
  },
  FOLDINGSCREEN: {
    index: "/digital/foldingScreen",
    list: "/digital/foldingScreen/list",
  },
  TABLESETTING: {
    index: "/digital/tableSetting",
    list: "/digital/tableSetting/list",
  },
  CASES: {
    index: "/cases",
    list: "/cases/list",
  },
  ALIMTALK: {
    index: "/alimtalk",
  },
};
